module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxyZWN0IGZpbGw9IiNGRkYiIHg9IjIiIHk9IjIiIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgcng9IjIiLz48cGF0aCBkPSJNMTQgMnYxMm0xNyA1djE5TTkgMnYxOW0xNyA1djEyTTM4IDkuMDFIMTltMTkgNUgyNm0tMTIgMTJIMm0xOSA1SDIiLz48L2c+PC9nPjwvc3ZnPg==\""


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./images/repairs/flooring.svg
 ** module id = 3582
 ** module chunks = 3
 **/